import Vue from "vue";
import Vuex from "vuex";
import Vueditor from "vueditor";
import Vuelidate from "vuelidate";
import VueMeta from "vue-meta";
import App from "./App.vue";
import router from "./router";
import storeConfig from "./store";
import axios from "axios";
import config from "@/plugins/vueditor";

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(Vueditor, config);
Vue.use(Vuelidate);
Vue.use(VueMeta);

const store = new Vuex.Store(storeConfig);

if (process.env.NODE_ENV === "development") {
  // disable CORS
  axios.defaults.withCredentials = true;
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch("getUser").then(() => {
      if (store.getters.isAuth) {
        next();
        return;
      }
      next("/");
    });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
